import React from "react";
import TopCards from "./components/TopCards/page";
import ChartsSection from "./components/ChartsSection/page";
import LeaveRequests from "./components/LeaveRequests/page";
import Notifications from "./components/Notifications/page";
import RightPanel from "./components/RightPanel/page";
import BottomSection from "./components/BottomSection/page";

const OverviewDashboard = () => {
  return (
    <>
      <style>{`
        .ov-root {
          min-height: 100vh;
          background: #f8fafc;
          padding: 20px;
          box-sizing: border-box;
        }

        .ov-main-layout {
          display: flex;
          gap: 20px;
          align-items: flex-start;
          width: 100%;
        }

        .ov-left-content {
          flex: 1;
          display: flex;
          flex-direction: column;
          gap: 20px;
          min-width: 0;
        }

        .ov-sidebar {
          width: 280px;
          flex-shrink: 0;
          display: flex;
          flex-direction: column;
          gap: 20px;
        }

        .ov-mid-row {
          display: flex;
          gap: 20px;
        }

        .ov-mid-row > * {
          flex: 1;
          min-width: 0;
        }

        /* 🔴 Mobile Quick Actions (hidden by default) */
        .mobile-quick-actions {
          display: none;
        }

        /* ─── MOBILE FIX ─── */
        @media (max-width: 1200px) {
          .ov-main-layout {
            flex-direction: column;
          }

          .ov-sidebar {
            display: none; /* hide desktop sidebar */
          }

          .mobile-quick-actions {
            display: block; /* show inside content */
          }

          .ov-mid-row {
            flex-direction: column;
          }
        }
      `}</style>

      <div className="ov-root">
        <div className="ov-main-layout">

          <div className="ov-left-content">
            
            {/* Top Cards */}
            <TopCards />

            {/* ✅ QUICK ACTIONS HERE (ONLY MOBILE) */}
            <div className="mobile-quick-actions">
              <RightPanel />
            </div>

            {/* Charts */}
            <ChartsSection />

            {/* Other sections */}
            <div className="ov-mid-row">
              <LeaveRequests />
              <Notifications />
            </div>

            <BottomSection />
          </div>

          {/* ✅ DESKTOP SIDEBAR */}
          <div className="ov-sidebar">
            <RightPanel />
          </div>

        </div>
      </div>
    </>
  );
};

export default OverviewDashboard;